module.exports = __webpack_public_path__ + "static/media/game_consoles3.c57df39b.png";